/**
 * Code promo en un clic (blocks/cf-promo-code.liquid) : active le code
 * pour la session via /discount/CODE, il s'applique ensuite au paiement.
 */
class CfPromoCode extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return; // déjà initialisé (rappelé après déplacement dans le formulaire)
    this.initialized = true;
    this.moveIntoProductForm();
    this.button = this.querySelector('[data-ref="apply"]');
    this.message = this.querySelector('[data-ref="message"]');
    this.button.addEventListener('click', () => this.apply());
  }

  // Option « Dans le formulaire » : se place juste avant le cross-sell (le CSS du bloc fait passer
  // le cross-sell sous le bouton d'ajout au panier). Sans cross-sell, l'encart reste à sa place.
  // Normalement déjà fait par le script du bloc ; ceci couvre le rechargement dans l'éditeur.
  moveIntoProductForm() {
    if (this.dataset.placement !== 'product_form' || this.closest('.product-form__form')) return;
    const crossSell = this.closest('.shopify-section')?.querySelector('.product-form__form > .toggle-cross-sell');
    if (crossSell) crossSell.before(this);
  }

  apply() {
    const code = encodeURIComponent(this.dataset.code);
    this.button.disabled = true;

    fetch(`/discount/${code}`, { credentials: 'same-origin' })
      .then(() => {
        navigator.clipboard?.writeText(this.dataset.code).catch(() => {});
        this.button.textContent = this.dataset.applied;
        this.message.textContent = this.dataset.message;
        this.message.hidden = false;
      })
      .catch(() => {
        window.location.href = `/discount/${code}?redirect=${encodeURIComponent(window.location.pathname)}`;
      });
  }
}

if (!customElements.get('cf-promo-code')) {
  customElements.define('cf-promo-code', CfPromoCode);
}
